import React, { useState } from 'react'

export default (WrappedComponent) => {
    const hocComponent = (props) => {
        const [show, setShow] = useState(false);
        const handleClose = () => setShow(false);
        const handleShow = () => {
            setShow(true)
        };

        return <WrappedComponent
            {...props}
            show={show}
            handleClose={handleClose}
            handleShow={handleShow}
        />
    }

    return hocComponent
}
